import Modal from "@/components/modal";
import { Component } from "react";

class SearchHelp extends Component {
  render() { 
    return <Modal onClick={this.props.onClick} >
    <p className="text-orange bg-white px-4 py-3 mb-1">
      Pour affiner la recherche, il est possible d'utiliser les commandes suivantes :
    </p>
      <table className="w-full p-2 bg-white text-gray-light">
        <tr className="border-4 border-khaki-light bg-khaki-light">
          <td className="p-2 text-center">Commande</td>
          <td className="text-center">Exemple</td>
          <td>Résultat</td>
        </tr>
        <tr className="border-4 border-khaki-light">
          <td className="p-2 text-orange font-t-bold text-3xl text-center">" "</td>
          <td className="text-center"><span className="text-orange font-t-semibold">"</span>Projets web<span className="text-orange font-t-semibold">"</span></td>
          <td>Recherche l'expression complète</td>
        </tr>
        <tr className="border-4 border-khaki-light">
          <td className="p-2 text-orange font-t-bold text-3xl text-center">+</td>
          <td className="text-center">
            projets <span className="text-orange font-t-semibold">+</span>web<br />
            <span className="text-orange font-t-semibold">+</span>projets <span className="text-orange font-t-semibold"></span> web
          </td>
          <td>Le mot web est obligatoirement présent<br/>
            Les deux mots sont obligatoirement présents
          </td>
        </tr>
        <tr className="border-4 border-khaki-light">
          <td className="p-2 text-orange font-t-bold text-3xl text-center">*</td>
          <td className="text-center">neuro<span className="text-orange font-t-semibold">*</span></td>
          <td>Recherche tous les mots commençant par neuro : neurologie, neuropsychologie, etc.</td>
        </tr>
        <tr className="border-4 border-khaki-light">
          <td className="p-2 text-orange font-t-bold text-3xl text-center">~</td>
          <td className="text-center">oenologie<span className="text-orange font-t-semibold">~</span></td>
          <td>Recherche tous les mots qui ressemblent</td>
        </tr>
      </table>
  </Modal>;
  }
}
 
export default SearchHelp;